export default {"src":"/_next/static/media/KeepaLogoBlue.87552a36.svg","height":113,"width":280};